/**
 * Quick buy drawer inline-script revival.
 *
 * The drawer loads its content with fetch() + DOMParser and injects it with
 * replaceChildren() (assets/theme.js, QuickBuyDrawer.show()). Scripts parsed by
 * DOMParser are flagged as already-executed and never run once inserted, so an
 * inline script in the drawer's markup is dead on arrival.
 *
 * snippets/buy-buttons.liquid carries one - the add-to-cart price sync - and
 * without reviving it the drawer's price goes stale the moment the shopper
 * switches variant: the theme's BuyButtons component updates dataset.unitPrice
 * and the button label on variant change, but never the visible price text.
 *
 * Scripts with a [src] are deliberately left alone. They are page-wide and have
 * already run, so re-creating one would fetch and execute a second copy of that
 * library.
 */
(function () {
  function reviveInlineScripts(root) {
    var stale = root.querySelectorAll('script:not([data-revived]):not([src])');

    Array.prototype.forEach.call(stale, function (oldScript) {
      var newScript = document.createElement('script');
      Array.prototype.forEach.call(oldScript.attributes, function (attr) {
        newScript.setAttribute(attr.name, attr.value);
      });
      newScript.dataset.revived = 'true';
      newScript.textContent = oldScript.textContent;
      oldScript.replaceWith(newScript);
    });
  }

  function watchDrawer(drawer) {
    var scheduled = false;

    var observer = new MutationObserver(function () {
      if (scheduled) {
        return;
      }
      scheduled = true;

      // Coalesce the burst replaceChildren() produces into a single pass, and
      // let the injected content settle before we touch it.
      requestAnimationFrame(function () {
        scheduled = false;

        // Replacing a script that is a direct child of the drawer is itself a
        // childList mutation, so stay disconnected while rewriting.
        observer.disconnect();
        try {
          reviveInlineScripts(drawer);
        } finally {
          observer.observe(drawer, { childList: true });
        }
      });
    });

    observer.observe(drawer, { childList: true });
  }

  function init() {
    document.querySelectorAll('quick-buy-drawer').forEach(watchDrawer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
